<img class="heart" src="/assets/home/companies/heart.svg" />

<h4>Organizations worldwide operate their payments with <span class="blue-underline">BridgerPay</span></h4>

<bp-companies-tiles *bpIfGreaterThan="'PhoneLg'; else animatedLinesTpl"></bp-companies-tiles>

<ng-template #animatedLinesTpl>
	<bp-companies-tiles-phone></bp-companies-tiles-phone>
</ng-template>
